export const customfieldOptionType = [
    { value: "SELECT", label: "Select" },
    { value: "TEXT", label: "Text" }
]